import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import React from 'react';
import { Description, heading, PrivacyPolicyProps } from 'types/next';

interface ContentProps {
  contentData: PrivacyPolicyProps;
}

const PrivacyPolicy = ({ contentData }: ContentProps) => {
  return (
    <div className="p-4">
      {/* Service Name */}
      {contentData?.serviceName && (
        <h1 className="text-black-600 mb-40 text-[29px] md:text-[33px] lg:text-[36px]">{contentData?.serviceName}</h1>
      )}
      {contentData?.headings?.map((item: heading, index: number) => (
        <div key={index} className="mb-6">
          {/* Heading */}
          <h4 className="mb-14 font-body text-[20px] font-normal leading-[22px] md:text-[21px] lg:text-[22px]">
            {item?.subHeadings}
          </h4>

          {/* Descriptions */}
          {item?.description?.map((desc: Description, descIndex: number) => (
            <div className="mb-30" key={descIndex}>
              {/* Markdown Content */}
              <MarkDownDescription
                markdownText={desc?.greatSubHeading}
                classname="font-normal privacy-policy leading-relaxed mb-4"
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
